import React, { useEffect } from "react";
import { Space } from "@masterteam/mt-design-react";

import CommentInput from "./CommentInput";
import Comment from "./Comment";

function CommentsList({ comments, getData, callback, KPIDetails }) {
  useEffect(() => {
    getData();
  }, []);

  const updateComments = (newComment, type) => {
    const newComments = [...comments];
    if (type === "updateComment") {
      const index = newComments.findIndex((item) => item.ID === newComment.ID);
      newComments[index] = newComment;
    } else if (type === "deleteComment") {
      const index = newComments.findIndex((item) => item.ID === newComment.ID);
      newComments.splice(index, 1);
    } else {
      newComments.push(newComment);
    }
    callback(newComments);
  };

  return (
    <Space
      direction="vertical"
      size="large"
      className="comments-list"
      style={{ margin: "0 32px" }}
    >
      {KPIDetails?.CanComment ? (
        <CommentInput KPIDetails={KPIDetails} callback={updateComments} />
      ) : null}
      {comments.map((_item, _index) => (
        <Comment
          key={_item.ID}
          item={_item}
          KPIDetails={KPIDetails}
          callback={updateComments}
        />
      ))}
    </Space>
  );
}

export default CommentsList;
